import { Component, Input, OnInit, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ChatEvent, Participant } from '@shared/factories';
import { ChatEventsService      } from '@shared/services';

@Component({
  selector:      'chat-typing',
  templateUrl: './chat-typing.component.html',
  host: { class: 'am-flex-align gap-s pl-s pr-s font-s height-30', '[style.opacity]': '+!!typers?.length' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatTypingComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  @Input() myId:                 number;
  @Input() roomId:               number;
  @Input() getParticipantByIdFn: Function;

  typing:        any = {};
  typingTimeout: NodeJS.Timeout;
  constructor(
    private chatEventsService: ChatEventsService
  ) { }

  ngOnInit(): void {
    this.chatEventsService.chatEvents.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => this.typingHandler(event));
  }

  get typers(): string[] {
    return Object.keys(this.typing)?.map(id => this.getParticipantByIdFn(+id)).map((p: Participant) => p?.fullName);
  }

  private typingHandler(event: ChatEvent): void {
    if (event?.roomId === this.roomId) {
      if (event?.type === 'new_message' && this.typing[event.participantId]) delete this.typing[event.participantId];
      if (event?.type === 'typing_message' && event.participantId !== this.myId) {
        this.typing[event.participantId] = new Date();
        clearInterval(this.typingTimeout);
        this.typingTimeout = setInterval(() => {
          if (!Object.keys(this.typing).length) clearInterval(this.typingTimeout);
          else for (const participant in this.typing) { if (new Date().getTime() - this.typing[participant].getTime() > 5000) delete this.typing[participant]; }
        }, 500);
      }
    }
  }

}
